import React from 'react';
import { CalendarCheck } from 'lucide-react';

type Props = {
  seen: boolean;
  type: 'order' | 'payout';
  title: string;
  createdAt?: string;
};

export default function NotificationCards({
  title,
  createdAt,
  type,
  seen,
}: Props) {
  return (
    <div className="p-3 w-full rounded-sm border bg-gray-50 border-border space-y-1">
      <div className="flex items-center justify-between gap-4">
        <p className="capitalize medium-emphasis-text text-blue-950">{type}</p>
        {!seen && (
          <span className="py-1 px-4 text-customs-bright-cyan border border-customs-bright-cyan bg-white rounded-sm ">
            <p>New</p>
          </span>
        )}
      </div>
      <h6 className="w-full font-semibold line-clamp-2 high-emphasis-text">
        {title}
      </h6>
      {createdAt && (
        <small className="medium-emphasis-text flex items-center gap-1">
          <span>
            <CalendarCheck className="size-3" />
          </span>
          <span>{createdAt}</span>
        </small>
      )}
    </div>
  );
}
